import { AuthState } from './auth';

export default {
	setLoader(state: AuthState, loader: boolean): void {
		state.loader = loader
	},
	setError(state: AuthState, error: any): void {
		state.error = error
	}
}